import { DataFieldType } from ".";

export class DataField{
    static readonly $type: string = "DataField";
    readonly $type: string = DataField.$type;
    public id!:number;
    public name!:string;
    public dataType!: DataFieldType;
}